<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';

export default {
  mixins: [fandomBasicMixin],
  data: function () {
    return { };
  },
  mounted: function () {
  },
  computed: {
    events() {
      let events = [ ];
      let months = {
        "it": ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
        "en": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
      };
      let lang = this.pageModel.context.map.lang;
      this.content.events.forEach((date, index) => {
        let d = new Date(date.date)
        events[index] = {
          "day": d.getDate(),
          "month": months[lang][d.getMonth()],
          "year": d.getFullYear(),
          "description": date.description
        }
      });
      return events;
    }
  }
};
</script>

<template>
  <div v-easyadmin="easyadminId" :class="contentType" class="py-4" v-if="isContentVisibleToUser()" table-events-component>
    <div class="row m-0 border-top border-left">
      <div
        v-for="(date,index) in events" 
        class="col-12 col-md-6 col-lg-12 col-xl-6 member d-flex flex-column justify-content-begin align-items-start border-bottom border-right py-3"
        :key="`date-${index}`"
      >
        <p class="text-primary mb-2">
          <i class="fal fa-calendar mr-3 text-dark"></i>
          <span class="h1">{{date['day']}}</span>
          {{ ` ${date['month']} ${ date['year'] }` }}
        </p>
        <small v-html="date['description']" class="mb-0 description"></small>      
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[table-events-component] {

  .description p {
    margin-bottom: 0;
  }

  .fa-calendar {
    font-size: 1.75rem;
  }
}

</style>